import { render } from "./Booking_Transport.vue?vue&type=template&id=6911944d&scoped=true"
import script from "./Booking_Transport.vue?vue&type=script&lang=js"
export * from "./Booking_Transport.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6911944d"

export default script